import React, {useEffect} from 'react';
import Loader from '../Loader';
import MessageView from '../MessageView';
import {
  fetchError,
  showMessage,
  useInfoViewActionsContext,
  useInfoViewContext,
} from './InfoViewContext';

interface InfoViewProps {}

const InfoView: React.FC<InfoViewProps> = () => {
  const {error, loading, message} = useInfoViewContext();
  const dispatch = useInfoViewActionsContext()!;

  useEffect(() => {
    if (loading) {
      console.log('loading spinner');
    } else {
      console.log('No loading spinner');
    }
  }, [loading]);
  useEffect(() => {
    if (error) {
      setTimeout(() => {
        dispatch(fetchError(''));
      }, 6000);
    }
  }, [error]);
  useEffect(() => {
    if (message) {
      setTimeout(() => {
        dispatch(showMessage(''));
      }, 6000);
    }
  }, [message]);

  return (
    <>
      <MessageView
        open={!!message}
        variant='success'
        message={message.toString()}
      />
      <MessageView open={!!error} variant='error' message={error.toString()} />
      {loading && <Loader />}
    </>
  );
};

export default InfoView;
